import Button from '@/components/Buttons/Button';
import ShareMenu from '@/components/ShareMenu/ShareMenu';
import ShareBlack from '@/images/ShareBlack.svg';
import { currentAgentOptionList } from '@/pages/agents/components/AgentOptionsList';
import { createShareUrl, sendShareMixpanelEvent } from '@/utils/shareUtils';
import styled from '@emotion/styled';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { useState } from 'react';
import { useSetRecoilState } from 'recoil';

// todo - should be replaced to new white button
const StyledButton = styled(Button)<{ white?: boolean }>`
    background-color: ${({ theme, white }) => white && theme.colors.white};
    color: ${({ theme, white }) => white && theme.colors.black[800]};
    border-color: ${({ theme, white }) => white && theme.colors.black[300]};

    :hover {
        border-color: ${({ theme, white }) => white && theme.colors.black[300]} !important;
    }
`;

interface Props {
    clientKey?: string;
    agentId: string | null;
    white?: boolean;
}

export const AgentShareButton = ({ clientKey, agentId, white }: Props) => {
    const [shareAnchorEl, setShareAnchorEl] = useState<HTMLButtonElement | null>(null);
    const setCurrentOptionList = useSetRecoilState(currentAgentOptionList);
    const [isShareClicked, setIsShareClicked] = useState(false);

    const handleShare = (option: string) => {
        sendShareMixpanelEvent({
            to: option,
            modal: 'play',
            item: { id: agentId || '', type: 'agent' },
        });
    };

    return (
        <>
            <StyledButton
                white={white}
                color="secondary"
                variant="outlined"
                startIcon={<img role="none" src={ShareBlack} />}
                onClick={e => {
                    setIsShareClicked(!isShareClicked);
                    setShareAnchorEl(e.currentTarget);
                }}
                disabled={false}
                endIcon={isShareClicked ? <KeyboardArrowUp /> : <KeyboardArrowDown />}>
                Share
            </StyledButton>
            <ShareMenu
                id="agent-share-menu"
                createShareUrl={(option: string) => createShareUrl({ itemId: agentId || '', from: option, type: 'agent', clientKey })}
                handleShare={handleShare}
                open={!!shareAnchorEl}
                anchorEl={shareAnchorEl}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: -10, horizontal: -20 }}
                onClose={() => {
                    setIsShareClicked(!isShareClicked);
                    setShareAnchorEl(null);
                    setCurrentOptionList(null);
                }}
            />
        </>
    );
};
